import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  computePortfolioBalanceUsd,
  getCoinUnits,
  getCoinUsd,
  getPriceUsd,
  formatUsd,
  formatCryptoAmount,
} from '../utils/balanceUtils';

/**
 * Live portfolio balances that revalue crypto holdings when coinRates change.
 */
export function usePortfolioBalance() {
  const fundings = useSelector((state) => state.wallet.fundings);
  const coinRates = useSelector((state) => state.coins.coinRates);
  const tradings = useSelector((state) => state.history.tradings);
  const investments = useSelector((state) => state.history.investments);
  const withdrawals = useSelector((state) => state.history.withdrawals);
  const copyings = useSelector((state) => state.history.copyings);

  const ledger = useMemo(
    () => ({ fundings, tradings, investments, withdrawals }),
    [fundings, tradings, investments, withdrawals]
  );

  const totalWalletUsd = useMemo(
    () =>
      computePortfolioBalanceUsd({
        fundings,
        tradings,
        investments,
        withdrawals,
        copyings,
        coinRates,
      }),
    [fundings, tradings, investments, withdrawals, copyings, coinRates]
  );

  const getUnits = (symbol) => getCoinUnits(symbol, ledger);

  const getUsd = (symbol) => getCoinUsd(symbol, getUnits(symbol), coinRates);

  const getBtcEquivalent = () => {
    const btcPrice = getPriceUsd('BTC', coinRates);
    if (!btcPrice) return '0.00000000';
    return (totalWalletUsd / btcPrice).toFixed(8);
  };

  return {
    totalWalletUsd,
    getCoinUnits: getUnits,
    getCoinUsd: getUsd,
    getBtcEquivalent,
    getPriceUsd: (symbol) => getPriceUsd(symbol, coinRates),
    formatUsd,
    formatCryptoAmount,
    coinRates,
    ledger,
  };
}

export default usePortfolioBalance;
